module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transitionName
    }
  }, [_c('div', {
    class: _vm.classes,
    style: (_vm.styles)
  }, [(_vm.type === 'notice') ? [_c('div', {
    ref: "content",
    class: [_vm.baseClass + '-content'],
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }), _vm._v(" "), (_vm.closable) ? _c('a', {
    class: [_vm.baseClass + '-close'],
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "ivu-icon ivu-icon-ios-close-empty"
  })]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.type === 'message') ? [_c('div', {
    ref: "content",
    class: [_vm.baseClass + '-content']
  }, [_c('div', {
    class: [_vm.baseClass + '-content-text'],
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }), _vm._v(" "), (_vm.closable) ? _c('a', {
    class: [_vm.baseClass + '-close'],
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "ivu-icon ivu-icon-ios-close-empty"
  })]) : _vm._e()])] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4228af72"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview/src/components/base/notification/notice.vue
// module id = 627
// module chunks = 1